import { INTEGRATION_VENDORS } from '../../../common/constants/IntegrationConstants';
import {
  fetchOutlookCalendarMetadata,
  connectOutlookCalendar,
  disconnectOutlookCalendar,
} from '../../routines/integrations/outlookCalendarRoutines';
import { fetchIntegrations } from '../../routines/integrations/integrationDataRoutines';

const initialState = {
  metadata: null,
  integration: null,
  connected: false,
  loading: false,
  error: null,
};

function outlookCalendarReducer(state = initialState, action) {
  switch (action.type) {
    case fetchOutlookCalendarMetadata.TRIGGER:
    case fetchIntegrations.TRIGGER:
    case connectOutlookCalendar.TRIGGER:
    case disconnectOutlookCalendar.TRIGGER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case fetchOutlookCalendarMetadata.SUCCESS: {
      const { metadata } = action.payload;

      return {
        ...state,
        loading: false,
        metadata,
      };
    }
    case fetchIntegrations.SUCCESS: {
      const { user: userIntegrations } = action.payload;
      const integration = userIntegrations.find(
        (_integration) =>
          _integration.vendor === INTEGRATION_VENDORS.OUTLOOK_CALENDAR
      );

      return {
        ...state,
        connected: !!integration,
        loading: false,
        integration,
      };
    }
    case connectOutlookCalendar.SUCCESS: {
      const { integration } = action.payload;

      return {
        ...state,
        loading: false,
        connected: true,
        integration,
      };
    }
    case disconnectOutlookCalendar.SUCCESS:
      return {
        ...initialState,
        metadata: state.metadata,
      };
    case fetchOutlookCalendarMetadata.FAILURE:
    case connectOutlookCalendar.FAILURE: {
      const { error } = action.payload;

      return {
        ...state,
        loading: false,
        error,
      };
    }
    case disconnectOutlookCalendar.FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

export default outlookCalendarReducer;
